/* ============================================================
   メガメニュー開閉アニメーション（GSAP）
   - PC（>=990px）のホバーで開閉。ホバー意図の遅延つき。
   - 開：上から幕が降りる（clip-path）＋カテゴリの時間差フェード＋背景ディム。
   - 閉：幕が上へ retract ＋ディムフェードアウト。
   - prefers-reduced-motion では即時表示。
   - GSAP 未ロード時はアニメ無しの開閉にフォールバック。
   ============================================================ */
(function () {
  'use strict';

  var OPEN_DELAY = 150; // ホバー意図の遅延(ms)
  var HIDDEN_CLIP = 'inset(0% 0% 100% 0%)';
  var SHOWN_CLIP = 'inset(0% 0% 0% 0%)';

  function init() {
    if (window.innerWidth < 990) return;

    var gsap = window.gsap;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var backdrop = document.querySelector('.mega-menu__backdrop');
    var active = null;
    var openTimer = null;

    var headerMenus = document.querySelectorAll('header-menu');
    if (!headerMenus.length) return;

    /* ---------- GSAP 未ロード時のフォールバック（アニメ無し） ---------- */
    if (!gsap) {
      headerMenus.forEach(function (hm) {
        var det = hm.querySelector('details.mega-menu');
        if (!det) return;
        hm._locked = false;
        var origClose = hm.close;
        hm.close = function () {
          if (hm._locked) return;
          if (origClose) origClose.call(hm);
        };
        hm.addEventListener('mouseenter', function () {
          clearTimeout(openTimer);
          if (active && active !== det) {
            active._hm._locked = false;
            active.removeAttribute('open');
          }
          hm._locked = true;
          active = det;
          active._hm = hm;
          openTimer = setTimeout(function () {
            det.setAttribute('open', '');
            if (backdrop) backdrop.style.cssText += ';opacity:1;visibility:visible;';
          }, OPEN_DELAY);
        });
      });
      document.addEventListener('mouseover', function (e) {
        if (!active) return;
        if (e.target.closest('header-menu')) return;
        if (e.target.closest('.mega-menu__content')) return;
        clearTimeout(openTimer);
        active._hm._locked = false;
        active.removeAttribute('open');
        active = null;
        if (backdrop) backdrop.style.cssText += ';opacity:0;visibility:hidden;';
      });
      bindClickNav();
      return;
    }

    /* ---------- 通常（GSAP）---------- */
    var DUR_OPEN = reduce ? 0 : 0.5;
    var DUR_CLOSE = reduce ? 0 : 0.35;
    var DUR_ITEMS = reduce ? 0 : 0.4;
    var DUR_DIM = reduce ? 0 : 0.3;

    if (backdrop) gsap.set(backdrop, { autoAlpha: 0 });

    var entries = [];
    headerMenus.forEach(function (hm) {
      var det = hm.querySelector('details.mega-menu');
      if (!det) return;
      var content = det.querySelector('.mega-menu__content');
      if (!content) return;

      var entry = {
        hm: hm,
        det: det,
        content: content,
        items: content.querySelectorAll('.mega-menu__category-item')
      };
      entries.push(entry);

      // 初期状態（隠す）。GSAP のインラインstyleで制御
      gsap.set(content, {
        clipPath: HIDDEN_CLIP,
        opacity: 0,
        visibility: 'hidden',
        pointerEvents: 'none'
      });

      // ホバー中は Shopify の close を抑止
      hm._locked = false;
      var origClose = hm.close;
      hm.close = function () {
        if (hm._locked) return;
        if (origClose) origClose.call(hm);
      };

      hm.addEventListener('mouseenter', function () {
        clearTimeout(openTimer);
        if (active && active.det !== det) {
          active.hm._locked = false;
          closeMenu(active, true); // 別メニューは即閉じ
        }
        hm._locked = true;
        active = entry;
        openTimer = setTimeout(function () {
          openMenu(entry);
        }, OPEN_DELAY);
      });
    });

    function openMenu(entry) {
      var content = entry.content;
      var items = entry.items;
      entry.det.setAttribute('open', '');
      gsap.killTweensOf(content);
      if (items.length) gsap.killTweensOf(items);

      var tl = gsap.timeline();
      tl.set(content, { visibility: 'visible', pointerEvents: 'auto' })
        .to(content, {
          clipPath: SHOWN_CLIP,
          opacity: 1,
          duration: DUR_OPEN,
          ease: 'power3.out'
        });
      if (items.length) {
        tl.fromTo(
          items,
          { y: 18, opacity: 0 },
          { y: 0, opacity: 1, duration: DUR_ITEMS, stagger: reduce ? 0 : 0.05, ease: 'power2.out' },
          reduce ? 0 : '-=0.3'
        );
      }
      if (backdrop) gsap.to(backdrop, { autoAlpha: 1, duration: DUR_DIM, ease: 'power1.out' });
    }

    function closeMenu(entry, immediate) {
      var content = entry.content;
      var items = entry.items;
      gsap.killTweensOf(content);
      if (items.length) gsap.killTweensOf(items);
      if (backdrop) gsap.to(backdrop, { autoAlpha: 0, duration: immediate ? 0 : 0.25 });

      var finish = function () {
        gsap.set(content, { visibility: 'hidden', pointerEvents: 'none' });
        if (items.length) gsap.set(items, { clearProps: 'all' });
        entry.det.removeAttribute('open');
      };

      if (immediate) {
        gsap.set(content, { clipPath: HIDDEN_CLIP, opacity: 0 });
        finish();
        return;
      }
      gsap.to(content, {
        clipPath: HIDDEN_CLIP,
        opacity: 0,
        duration: DUR_CLOSE,
        ease: 'power3.in',
        onComplete: finish
      });
    }

    // カーソルが header-menu / メガメニュー外に出たら閉じる
    document.addEventListener('mouseover', function (e) {
      if (!active) return;
      if (e.target.closest('header-menu')) return;
      if (e.target.closest('.mega-menu__content')) return;
      clearTimeout(openTimer);
      active.hm._locked = false;
      closeMenu(active, false);
      active = null;
    });

    bindClickNav();
  }

  // PC では summary クリックで <details> を開かず data-href へ遷移
  function bindClickNav() {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.mega-menu > summary');
      if (!summary) return;
      e.preventDefault();
      var href = summary.getAttribute('data-href');
      if (href) window.location.href = href;
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
